import * as React from 'react';
import {Switch, Route} from 'react-router-dom';

import {setBodyId} from '../../../dom';

import {mountUserAiFeatures} from '../ai-features/user/mount-user-ai-features';
import {mountDirectorySync} from '../directory-sync/mount-directory-sync';
import {mountEmailSignatureById} from '../email/mount-email-signature-by-id';
import {mountLicensing} from '../licensing/mount-licensing';
import {mountMfa} from '../mfa/mount-mfa';
import {SetupPage} from '../setup-page';

import {mountDsUsersBanner} from './mount-ds-users-banner';
import {mountUserPageBanners} from './mount-user-page-banners';
import {mountUsersBanner} from './mount-users-banner';
import {mountUsersCueCards} from './mount-users-cue-cards';
import {mountRolesAndPermissionsTables} from './roles-permissions/mount-roles-and-permissions-tables';
import {mountUserSetupSidebar} from './sidebar/mount-user-setup-sidebar';
import {mountUsersTable} from './users-table/mount-users-table';

export function UserRoot(props: {pathname: string}) {
    React.useEffect(() => {
        setBodyClasses(props.pathname);
    }, [props.pathname]);

    const splitPath = props.pathname.split('/');
    const userId = `${splitPath[splitPath.length - 1]}-Users`;

    return (
        <Switch>
            <Route
                path='/setup/user/settings'
                render={(routeProps) => {
                    setBodyId('myaccount');

                    return (
                        <SetupPage
                            pageTitle='Account settings'
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                            userId={userId}
                            onViewRendered={(id?: string | null) => {
                                mountLicensing(userId);
                                mountUserAiFeatures(userId);
                                mountMfa(id);
                                mountDirectorySync(userId);
                                mountUserPageBanners();
                            }}
                        />
                    );
                }}
            />
            <Route
                path='/setup/user/email'
                render={(routeProps) => {
                    setBodyId('myaccount');

                    return (
                        <SetupPage
                            pageTitle='Email settings'
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                            onViewRendered={mountEmailSignatureById(userId)}
                        />
                    );
                }}
            />
            <Route
                path='/setup/user/notifications'
                render={(routeProps) => {
                    setBodyId('myaccount');

                    return (
                        <SetupPage
                            pageTitle='Notification settings'
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                        />
                    );
                }}
            />
            <Route
                path='/setup/user'
                render={(routeProps) => {
                    setBodyId('users');

                    return (
                        <SetupPage
                            pageTitle='Users & teams'
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                            onViewRendered={() => {
                                mountUserSetupSidebar();
                                mountRolesAndPermissionsTables();
                                mountUsersBanner();
                                mountUsersTable();
                                mountDsUsersBanner();
                                mountUsersCueCards();
                            }}
                        />
                    );
                }}
            />
        </Switch>
    );
}

const baseBodyClasses = ['manage', 'page', 'settings'];

function setBodyClasses(pathname: string): void {
    const body = document.querySelector('body');

    if (!body) return;

    if (pathname.includes('/setup/user/settings')) {
        body.className = baseBodyClasses
            .concat(['list', 'fixed-width', 'account-settings'])
            .join(' ');
    } else if (pathname.includes('/setup/user/email')) {
        body.className = baseBodyClasses.concat(['list', 'fixed-width', 'account-email']).join(' ');
    } else if (pathname.includes('/setup/user/notifications')) {
        body.className = baseBodyClasses
            .concat(['list', 'fixed-width', 'account-notifications'])
            .join(' ');
    } else if (pathname.includes('/setup/user')) {
        body.className = baseBodyClasses.concat(['list', 'fixed-width']).join(' ');
    } else {
        body.className = baseBodyClasses.join(' ');
    }
}
